<template>
  <span :class="[chipShapeClass, chipTypeClass, chipSubwayClass, chipSizeClass]">
    <slot></slot>
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";

/* ------------------------------------------------------------
                          Props
   ------------------------------------------------------------ */
const props = defineProps({
  shape: {
    type: String,
    default: "square", // 'square' or 'round'
  },
  type: {
    type: String,
    default: "filled", // 'filled', 'outlined', 'light', or 'subway'
  },
  color: {
    type: String,
    default: "", // 색상 또는 노선도명 (가이드참고)
  },
  size: {
    type: String,
    default: "", //lg(height: 24px; 전용)
  },
});

/* ------------------------------------------------------------
                          Computed Properties
   ------------------------------------------------------------ */
/** 칩 형태 클래스 */
const chipShapeClass = computed(
  () => ({ round: "round_chips", circle: "circle_chips" })[props.shape!] ?? "square_chips"
);

/** 칩 타입 클래스 */
const chipTypeClass = computed(() => {
  return props.type !== "subway" ? `${props.type}_${props.color}` : "";
});

/** 칩 서브웨이 클래스 */
const chipSubwayClass = computed(() => {
  return props.type === "subway" ? `subway ${props.color}` : "";
});

/** 칩 크기 클래스 */
const chipSizeClass = computed(() => {
  return props.size ? `chip_${props.size}` : "";
});
</script>
